// The <Flex /> component is an extension of the <Box /> component with
// `display: flex` and props for using flexbox.
import styled from 'react-emotion'
import {
  alignContent,
  alignItems,
  alignSelf,
  color,
  flex,
  flexBasis,
  flexDirection,
  flexWrap,
  justifyContent,
  justifySelf,
  propTypes,
  space,
  width,
  height,
} from 'styled-system'
import PropTypes from 'prop-types'
import theme from './theme'
import { noOverflow } from './styles'

const Flex = styled.div`
  display: flex;
  ${alignContent}
  ${alignItems}
  ${alignSelf}
  ${color}
  ${flexBasis};
  ${flexDirection};
  ${flexWrap}
  ${flex}
  ${justifyContent}
  ${justifySelf}
  ${noOverflow}
  ${space}
  ${width}
  ${height}
`

Flex.defaultProps = {
  theme,
  noOverflow: false,
}

Flex.propTypes = {
  ...propTypes.alignContent,
  ...propTypes.alignItems,
  ...propTypes.alignSelf,
  ...propTypes.color,
  ...propTypes.flex,
  ...propTypes.flexBasis,
  ...propTypes.flexDirection,
  ...propTypes.flexWrap,
  ...propTypes.justifyContent,
  ...propTypes.justifySelf,
  ...propTypes.order,
  ...propTypes.space,
  ...propTypes.width,
  ...propTypes.height,
  noOverflow: PropTypes.bool,
}

Flex.displayName = 'Flex'

export default Flex
